"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var detect_browser_1 = require("detect-browser"),
    rxjs_1 = require("rxjs"),
    CodeType_1 = require("../model/CodeType"),
    UsabilityResponse_1 = require("../model/UsabilityResponse"),
    Interaction_1 = require("./Interaction");

exports.UsabilityEvent = {
  BrowserNotSupported: "browser_not_supported",
  BrowserSupportUnknown: "browser_support_unknown",
  DeviceNotSupported: "device_not_supported",
  DisplayTooSmallForDisplacement: "display_too_small_displacement",
  DisplayTooSmallForPack: "display_too_small_pack",
  DisplayTooSmallForTick: "display_too_small_tick",
  DisplayTooSmallForTornado: "display_too_small_tornado",
  HoldCardBelowSwipeFinger: "hold_card_below_swipe",
  HoldWithOneFinger: "hold_with_one_finger_only",
  PickUpCodeFromDisplayAndRetry: "pick_up_code_from_display_and_retry",
  ShouldAddToHomeScreen: "display_small_should_add_to_home",
  SwipeIncomplete: "swipe_incomplete",
  TakeDeviceInHand: "take_device_in_hand",
  UsePointingFinger: "finger_too_thick"
};

var Usability = function () {
  function e(e) {
    this.subject = new rxjs_1.ReplaySubject(), this.twoFingerHoldingMode = !1, this.window = void 0, this.Config = {
      browsersSupported: ["ios", "chrome", "opera", "crios", "ios-webview", "fxios"],
      browsersUnsupported: ["firefox"],
      deviceOnDeskTimeout: 2e3,
      holdWithOneFingerTimeout: 1e3,
      interactionTimeout: 5e3
    }, this.intersected = !1, this.highestProgress = 0, this.paused = !1, this.window = window, this.strings = e;
  }

  return e.prototype.init = function (e) {
    var i = this,
        t = detect_browser_1.detect();
    t && t.name ? this.Config.browsersUnsupported.includes(t.name) ? this.subject.next(new UsabilityResponse_1.UsabilityResponse(this.strings, exports.UsabilityEvent.BrowserNotSupported)) : this.Config.browsersSupported.includes(t.name) || this.subject.next(new UsabilityResponse_1.UsabilityResponse(this.strings, exports.UsabilityEvent.BrowserSupportUnknown)) : this.subject.next(new UsabilityResponse_1.UsabilityResponse(this.strings, exports.UsabilityEvent.BrowserSupportUnknown)), this.window.addEventListener("deviceorientation", this.orientationEvent.bind(this), !1);
    var s = .34 * this.window.screen.height,
        o = this.window.screen.width * (50 / 150);
    0 < e.ppi && 0 < e.devicePixelRatio && (s = this.window.screen.height * e.devicePixelRatio / e.ppi * 25.4, o = this.window.screen.width * e.devicePixelRatio / e.ppi * 25.4);
    var n = this.window.innerHeight || this.window.screen.height,
        r = this.window.innerWidth || this.window.screen.width,
        a = .34 * n,
        p = r * (50 / 150);
    0 < e.ppi && 0 < e.devicePixelRatio && (a = n * e.devicePixelRatio / e.ppi * 25.4, p = r * e.devicePixelRatio / e.ppi * 25.4);
    var l = !1;
    e.codeSetTypes.forEach(function (e) {
      switch (e) {
        case CodeType_1.CodeType.Displacement:
        case CodeType_1.CodeType.DisplacementZip:
        case CodeType_1.CodeType.DisplacementZipShort:
          (s < 85 || o < 48) && i.subject.next(new UsabilityResponse_1.UsabilityResponse(i.strings, exports.UsabilityEvent.DisplayTooSmallForDisplacement)), (a < 85 || p < 48) && (l = !0);
          break;

        case CodeType_1.CodeType.Tick:
          (s < 85 || o < 48) && i.subject.next(new UsabilityResponse_1.UsabilityResponse(i.strings, exports.UsabilityEvent.DisplayTooSmallForTick)), (a < 85 || p < 48) && (l = !0);
          break;

        case CodeType_1.CodeType.Pack:
          s < 85 && i.subject.next(new UsabilityResponse_1.UsabilityResponse(i.strings, exports.UsabilityEvent.DisplayTooSmallForPack)), a < 85 && (l = !0);
          break;

        case CodeType_1.CodeType.Tornado:
          (s < 85 || o < 48) && i.subject.next(new UsabilityResponse_1.UsabilityResponse(i.strings, exports.UsabilityEvent.DisplayTooSmallForTornado)), (a < 85 || p < 48) && (l = !0);
      }
    }), l && this.subject.next(new UsabilityResponse_1.UsabilityResponse(this.strings, exports.UsabilityEvent.ShouldAddToHomeScreen)), e.deviceSupport && !1 === e.deviceSupport.supported && this.subject.next(new UsabilityResponse_1.UsabilityResponse(this.strings, exports.UsabilityEvent.DeviceNotSupported));
  }, e.prototype.progress = function (e) {
    this.highestProgress = Math.max(e.progress, this.highestProgress);
  }, e.prototype.interaction = function (e) {
    var i = this;
    this.paused || (e.event === Interaction_1.InteractionEvent.Started && (this.highestProgress = 0, this.intersected = !1, this.liftUpCardTimer = setTimeout(function () {
      i.subject.next(new UsabilityResponse_1.UsabilityResponse(i.strings, exports.UsabilityEvent.PickUpCodeFromDisplayAndRetry));
    }, this.Config.interactionTimeout)), e.event === Interaction_1.InteractionEvent.Complete && null !== this.liftUpCardTimer && this.clearLiftUpCardTimer(), e.event !== Interaction_1.InteractionEvent.Changed || this.twoFingerHoldingMode || (2 < e.activeSignals && null == this.tooManyTouchesTimer ? this.tooManyTouchesTimer = setTimeout(function () {
      i.subject.next(new UsabilityResponse_1.UsabilityResponse(i.strings, exports.UsabilityEvent.HoldWithOneFinger));
    }, this.Config.holdWithOneFingerTimeout) : e.activeSignals <= 2 && this.clearTooManyTouchesTimer()), e.event === Interaction_1.InteractionEvent.Complete && 50 < this.highestProgress && this.highestProgress < 100 && this.subject.next(new UsabilityResponse_1.UsabilityResponse(this.strings, exports.UsabilityEvent.SwipeIncomplete)));
  }, e.prototype.touchesCancelled = function () {
    this.paused || this.subject.next(new UsabilityResponse_1.UsabilityResponse(this.strings, exports.UsabilityEvent.PickUpCodeFromDisplayAndRetry));
  }, e.prototype.fingerTooThick = function () {
    this.paused || this.subject.next(new UsabilityResponse_1.UsabilityResponse(this.strings, exports.UsabilityEvent.UsePointingFinger));
  }, e.prototype.evaluateTouchData = function (e, i) {
    if (!this.paused && i === CodeType_1.CodeType.Displacement && 2 === e.size && !this.intersected) {
      var t = e.values(),
          s = t.next().value,
          o = t.next().value,
          n = s[s.length - 1],
          r = !1;

      if (o.forEach(function (e) {
        e.y - 50 >= n.y && (r = !0);
      }), r) {
        if (this.intersected = !0, this.twoFingerHoldingMode) return;
        this.subject.next(new UsabilityResponse_1.UsabilityResponse(this.strings, exports.UsabilityEvent.HoldCardBelowSwipeFinger));
      }
    }
  }, e.prototype.pause = function () {
    this.paused = !0, this.clearLiftUpCardTimer(), this.clearTakeDeviceInHandTimer(), this.clearTooManyTouchesTimer();
  }, e.prototype.resume = function () {
    this.paused = !1;
  }, e.prototype.orientationEvent = function (e) {
    var i = this;
    this.paused || (Math.abs(e.beta) < 2 && Math.abs(e.gamma) < 2 && null === this.takeDeviceInHandTimer ? this.takeDeviceInHandTimer = setTimeout(function () {
      i.subject.next(new UsabilityResponse_1.UsabilityResponse(i.strings, exports.UsabilityEvent.TakeDeviceInHand));
    }, this.Config.deviceOnDeskTimeout) : (2 <= Math.abs(e.beta) || 2 <= Math.abs(e.gamma)) && this.clearTakeDeviceInHandTimer());
  }, e.prototype.clearLiftUpCardTimer = function () {
    null !== this.liftUpCardTimer && (clearTimeout(this.liftUpCardTimer), this.liftUpCardTimer = null);
  }, e.prototype.clearTooManyTouchesTimer = function () {
    null !== this.tooManyTouchesTimer && (clearTimeout(this.tooManyTouchesTimer), this.tooManyTouchesTimer = null);
  }, e.prototype.clearTakeDeviceInHandTimer = function () {
    null !== this.takeDeviceInHandTimer && (clearTimeout(this.takeDeviceInHandTimer), this.takeDeviceInHandTimer = null);
  }, e;
}();

exports.Usability = Usability;